import axios from 'axios';

const getTimezone = async () => {
    const response = axios.get('/account/public/api/v1/timezone')
    
    return (await response).data;
};

export default getTimezone;